package data

import com.kinoshazam.data.Storage
import com.kinoshazam.data.models.AuthResult
import com.kinoshazam.data.models.LoginResult
import com.kinoshazam.data.models.RegistrationResult
import com.kinoshazam.data.models.VerifyEmailResult
import com.kinoshazam.data.models.VerifyOtpResult
import data.models.ChangePasswordData
import data.models.LogoutData
import data.models.OtpData
import data.models.RegistrationData
import data.models.RequestResetPasswordData
import data.models.ResetPasswordData
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody

class LoginRepository(
    private val httpClient: HttpClient,
    private val authHttpClient: HttpClient,
    private val storageUser: Storage,
    private val storageSecure: Storage,
) {

    suspend fun signOn(login: String, password: String): AuthResult<RegistrationResult> {
        return httpClient.post(urlString = "auth/register") {
            setBody(RegistrationData(login, password))
        }.body<AuthResult<RegistrationResult>>()
    }

    suspend fun login(login: String, password: String): AuthResult<LoginResult> {
        return httpClient.post(urlString = "auth/login") {
            setBody(
                RegistrationData(
                    email = login,
                    password = password,
                )
            )
        }.body<AuthResult<LoginResult>>()
    }

    suspend fun logout(refreshToken: String?) {
        // No Bearer: server identifies the session by refreshToken in the body.
        httpClient.post(urlString = "auth/logout") {
            setBody(
                LogoutData(
                    refreshToken = refreshToken,
                )
            )
        }
    }

    suspend fun verifyEmailOtp(email: String, otp: String): AuthResult<VerifyEmailResult> {
        return httpClient.post(urlString = "auth/verify-email") {
            setBody(
                OtpData(
                    email = email,
                    code = otp,
                )
            )
        }.body<AuthResult<VerifyEmailResult>>()
    }

    suspend fun verifyPasswordOtp(email: String, otp: String): AuthResult<VerifyOtpResult> {
        return httpClient.post(urlString = "auth/verifyPasswordOtp") {
            setBody(
                OtpData(
                    email = email,
                    code = otp,
                )
            )
        }.body<AuthResult<VerifyOtpResult>>()
    }

    suspend fun requestOtp(email: String) {
        httpClient.post(urlString = "auth/resendOtp") {
            setBody(
                OtpData(
                    email = email,
                    code = null,
                )
            )
        }
    }

    suspend fun resetPassword(token: String? = null, code: String? = null, password: String) {
        val response = httpClient.post(urlString = "auth/reset-password") {
            setBody(
                ResetPasswordData(
                    token = token,
                    code = code,
                    newPassword = password,
                )
            )
        }
    }

    suspend fun requestPasswordReset(email: String) {
        httpClient.post(urlString = "auth/requestPasswordReset") {
            setBody(
                RequestResetPasswordData(
                    email = email,
                )
            )
        }
    }

    suspend fun changePassword(currentPassword: String, newPassword: String) {
        val response = authHttpClient.post(urlString = "auth/change-password") {
            setBody(
                ChangePasswordData(
                    currentPassword = currentPassword,
                    newPassword = newPassword,
                )
            )
        }
    }
}